import { IconBook, IconClock, IconPlus } from '@tabler/icons-react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { getCourses } from '../../store/courseSlice';
import { getPrograms } from '../../store/programSlice';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import BreadcrumbNav from './BreadcrumbNav';

export default function ProgramCourses() {
    const { programId } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const programs = useSelector(state => state.program.list);
    const courses = useSelector(state => state.course.list);
    const loading = useSelector(state => state.program.loading);
    
    const program = programs.find(p => p.id === parseInt(programId));
    const programCourses = courses.filter(c => c.programId === parseInt(programId));

    useEffect(() => {
        dispatch(getPrograms());
        dispatch(getCourses(programId));
    }, [dispatch, programId]);

    const handleAddCourse = () => {
        navigate(`/curriculum/programs/${programId}/courses/new`);
    };

    const breadcrumbItems = [
        { label: 'Curriculum', href: '/curriculum' },
        { label: program?.name || 'Program', href: `/curriculum/programs/${programId}/courses` }
    ];

    if (loading) {
        return (
            <div className="flex items-center justify-center h-64">
                <div className="text-muted-foreground">Loading courses...</div>
            </div>
        );
    }

    if (!program) {
        return (
            <div className="flex items-center justify-center h-64">
                <div className="text-muted-foreground">Program not found</div>
            </div>
        );
    }

    return (
        <div className="space-y-6">
            <BreadcrumbNav items={breadcrumbItems} />
            
            <div className="flex items-center justify-between">
                <div>
                    <h1 className="text-3xl font-bold tracking-tight">{program.name}</h1>
                    <p className="text-muted-foreground">
                        {program.description || 'No description available'}
                    </p>
                </div>
                <Button onClick={handleAddCourse}>
                    <IconPlus className="mr-2 h-4 w-4" />
                    Add Course
                </Button>
            </div>

            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                {programCourses.map((course) => (
                    <Card 
                        key={course.id} 
                        className="h-full cursor-pointer transition-all duration-200 hover:shadow-lg hover:-translate-y-1 border-border hover:border-primary/20"
                    >
                        <CardHeader>
                            <CardTitle className="flex items-center gap-2">
                                <IconBook className="h-5 w-5 text-primary" />
                                {course.name}
                            </CardTitle>
                        </CardHeader>
                        <CardContent>
                            <p className="text-muted-foreground mb-4">
                                {course.description || 'No description available'}
                            </p>
                            <div className="flex items-center justify-between text-sm text-muted-foreground">
                                <div className="flex items-center gap-1">
                                    <IconClock className="h-4 w-4" />
                                    <span>{course.lessons?.length || 0} lessons</span>
                                </div>
                                <Link 
                                    to={`/curriculum/courses/${course.id}/lessons`}
                                    className="text-primary hover:text-primary/80 hover:underline"
                                >
                                    View Lessons →
                                </Link>
                            </div>
                        </CardContent>
                    </Card>
                ))}
            </div>


        </div>
    );
} 